var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "app-booking-side-menu",
        {
          attrs: {
            "min-width": 15,
            "fixed-menu": false,
            "booking-nos": _vm.value.bookingNos,
            "current-booking-no": _vm.value.bookingNo,
            "current-route-name": _vm.$route.name,
            "is-new": _vm.value.isNew,
            "is-synced": _vm.value.isSynced,
          },
          on: { "select-booking": _vm.selectBooking },
        },
        [
          _c(
            "aside",
            {
              staticClass: "menu",
              attrs: { slot: "side-menu" },
              slot: "side-menu",
            },
            [
              _c("div", { staticClass: "menu-label" }, [
                _c("div", { staticClass: "columns is-gapless mb-2" }, [
                  _c("div", { staticClass: "column" }, [
                    _c(
                      "span",
                      {
                        staticClass: "title is-6",
                        staticStyle: { "white-space": "nowrap" },
                      },
                      [_vm._v(" Claim No.: " + _vm._s(_vm.entityName) + " ")]
                    ),
                  ]),
                ]),
                _vm.quoteId
                  ? _c("div", { staticClass: "columns is-gapless mb-1" }, [
                      _c("div", { staticClass: "column" }, [
                        _c(
                          "span",
                          {
                            staticClass: "title is-6 is-link",
                            staticStyle: { "white-space": "nowrap" },
                          },
                          [
                            _vm._v(" Quote No.: "),
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.handleQuoteClick()
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(_vm.quoteNo) + " ")]
                            ),
                          ]
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]),
              _c("ul", { staticClass: "menu-list" }, [
                _c(
                  "li",
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            name: _vm.routeTypes.BookingHeader.name,
                            params: { quoteId: _vm.$route.params.quoteId },
                            query: _vm.$route.query,
                          },
                          "active-class": "is-active",
                          exact: "",
                        },
                      },
                      [
                        _c("span", [
                          _c(
                            "span",
                            { staticClass: "has-badge-child-offset2" },
                            [_vm._v("Details")]
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm.value.isRepx
                  ? _c(
                      "li",
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                name: _vm.routeTypes.BookingRepx.name,
                                params: { quoteId: _vm.$route.params.quoteId },
                                query: _vm.$route.query,
                              },
                              "active-class": "is-active",
                              exact: "",
                            },
                          },
                          [_c("span", [_vm._v(" RepX Log ")])]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }